'use strict';


import {
    BackSide,
    Color, DoubleSide,
    Fog,
    Group,
    Mesh,
    MeshBasicMaterial, PlaneBufferGeometry,
    ShaderMaterial,
    SphereBufferGeometry,
    TextureLoader,
} from 'three';
import drizzleVertex from '../threejs/Shaders/weather/drizzle/vertex.glsl';
import drizzleFragment from '../threejs/Shaders/weather/drizzle/fragment.glsl';
import { PostFX } from '../post-processing/PostFX';
import { projectMode, threeJsVariables } from '../../settings';
import { basic_tile } from '../threejs/environment';
import { rotateToCamera } from '../controls/orbitControls';

export class Drizzle {

    static rainbow = null;
    static rainbowVisible = false;

    constructor () {

        this.fogColor = new Color(0.87,0.87,0.87);
        this.envFogDensity = 0.0005;
        this.bgFogDensity = 0.0005;

        if (!projectMode.LiteMode.isActive()) {
            const url = './assets/textures/rainbow/';
            const bg = threeJsVariables.scene.getObjectByName('Background');
            const textureLoader = new TextureLoader();

            Drizzle.rainbow = new Group();
            Drizzle.rainbow.name = 'rainbow';
            Drizzle.rainbow.position.copy(bg.position);
            Drizzle.rainbow.scale.copy(bg.scale);
            Drizzle.rainbow.rotation.copy(bg.rotation);

            Drizzle.rainbow.position.y = config.features.weather?.settings?.rainbow?.positionY || bg.position.y;

            bg.traverse(el => {
                if (el.isMesh){
                    const g = el.geometry.clone();
                    const m = new MeshBasicMaterial({
                        map: textureLoader.load(url + el.name + '.png'),
                        transparent: true
                    });

                    const mesh = new Mesh(g,m);
                    mesh.name = el.name;
                    Drizzle.rainbow.add(mesh);
                }
            });
        }

        this.material = new ShaderMaterial({
            vertexShader: drizzleVertex,
            fragmentShader: drizzleFragment,
            uniforms: {
                uTime: {
                    value: 0
                }
            }
        });

        this.effect = new PostFX('drizzle',threeJsVariables.renderer,this.material);

        return this;
    }

    enable() {
        this.effect.enable();

        if (!projectMode.LiteMode.isActive()) {
            /* ENV FOG */
            basic_tile.uniforms.fogColor.value.copy(this.fogColor);
            basic_tile.uniforms.fogDensity.value = this.envFogDensity;

            if (threeJsVariables.tilesRenderer){
                threeJsVariables.tilesRenderer.forEachLoadedModel((scene,tile)=>{
                    scene.traverse(obj => {
                        if ( obj.material) {
                            obj.material.uniforms.fogColor.value.copy(this.fogColor);
                            obj.material.uniforms.fogDensity.value = this.envFogDensity;
                        }
                    });
                });
            } else {
                let env = threeJsVariables.scene.getObjectByName('async env');
                env.traverse(obj => {
                    if ( obj.material) {
                        obj.material.uniforms.fogColor.value.copy(this.fogColor);
                        obj.material.uniforms.fogDensity.value = this.envFogDensity;
                    }
                });
            }

            /* BG FOG */
            const bg = threeJsVariables.scene.getObjectByName('Background');
            bg.traverse(obj => {
                if (obj.material) {
                    obj.material.uniforms.fogColor.value.copy(this.fogColor);
                    obj.material.uniforms.fogDensity.value = this.bgFogDensity;
                }
            });

            /* RAINBOW */
            threeJsVariables.scene.add(Drizzle.rainbow);
            Drizzle.rainbow.rotation.y = rotateToCamera();
            Drizzle.rainbowVisible = true;


            /* SCENE FOG */
            // threeJsVariables.scene.fog = new Fog(new Color().copy(this.fogColor),1.0,725);
        } else {
            projectMode.LiteMode.rainbowToggle('enable');
        }


    }

    disable() {
        this.effect.disable();

        if (!projectMode.LiteMode.isActive()) {
            /* ENV FOG */
            basic_tile.uniforms.fogDensity.value = 0.0;

            if (threeJsVariables.tilesRenderer){
                threeJsVariables.tilesRenderer.forEachLoadedModel((scene,tile)=>{
                    scene.traverse(obj => {
                        if ( obj.material) {
                            obj.material.uniforms.fogDensity.value = 0.0;
                        }
                    });
                });
            } else {
                let env = threeJsVariables.scene.getObjectByName('async env');
                env.traverse(obj => {
                    if ( obj.material) {
                        obj.material.uniforms.fogDensity.value = 0.0;
                    }
                });
            }

            /* BG FOG */
            const bg = threeJsVariables.scene.getObjectByName('Background');
            bg.traverse(obj => {
                if (obj.material) {
                    obj.material.uniforms.fogDensity.value = 0.0;
                }
            });


            /* RAINBOW */
            Drizzle.rainbowVisible = false;
            Drizzle.rainbow.removeFromParent();

            Drizzle.rainbow.traverse(el => {
                if (el.isMesh){
                    el.material.map.dispose();
                    el.material.dispose();
                    el.geometry.dispose();
                }
            });

            /* SCENE FOG */
            // threeJsVariables.scene.fog = null;

        } else {
            projectMode.LiteMode.rainbowToggle('disable');
        }
    }

    update(time) {
        if (this.effect.active) {
            this.material.uniforms.uTime.value = time;
        }
    }

    static rotateRainbow() {
        if (Drizzle.rainbow && Drizzle.rainbowVisible) {
            Drizzle.rainbow.rotation.y = rotateToCamera();
        }
    }
}